import { useMutation } from "@tanstack/react-query";
import { useStorage } from "reactfire";

import { UploadServicePhotoPropsType } from "@/domain/models/storage";

import { StorageApi } from "../api/StorageApi";

export const useUploadServicePhotoMutation = () => {
  const storage = useStorage();

  return useMutation<string, unknown, UploadServicePhotoPropsType>({
    mutationFn: params =>
      StorageApi.uploadServicePhoto({
        storage,
        jobId: params.jobId,
        serviceId: params.serviceId,
        baseName: params.baseName,
        base64PhotoString: params.base64PhotoString,
      }),
  });
};
